import React, { useState, useEffect } from "react";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";
import { useNavigate } from "react-router-dom";

const CadastroSessaoAula = () => {
  const navigate = useNavigate();
  const [nome, setNome] = useState("");
  const [resumo, setResumo] = useState("");
  const [disciplinas, setDisciplinas] = useState([]);
  const [disciplinasSelecionadas, setDisciplinasSelecionadas] = useState([]);
  const [sucesso, setSucesso] = useState(false);

  const professorId = Number(localStorage.getItem("user_id"));
  const { parametros } = useCliente();


  useEffect(() => {
    const carregarDisciplinas = async () => {
      try {
        const response = await axios.get(`/api/disciplinas/professor/${professorId}`);
        setDisciplinas(response.data);
      } catch (error) {
        console.error("Erro ao carregar disciplinas:", error);
      }
    };

    carregarDisciplinas();
  }, [professorId]);

  const handleDisciplinaCheckbox = (id) => {
    setDisciplinasSelecionadas((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id]
    );
  };

 

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("📍 handleSubmit DISPARADO");

  
    try {
      await axios.post("/api/sessoes_aula", {
        professor_id: professorId,
        nome,
        resumo,
        disciplinas_ids: disciplinasSelecionadas,
      });
  
      setSucesso(true);
      setTimeout(() => {
        navigate("/minhas-sessoes");
      }, 2000);
 
      
    } catch (error) {
      console.error("Erro ao cadastrar sessão:", error);
    }
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Cadastrar Sessão de Aula</h2>

      {sucesso && (
        <div className="sucesso-msg">
          Sessão cadastrada com sucesso!
        </div>
      )}


      <form onSubmit={handleSubmit}>
        {/* Nome da Sessão */}
        <div className="form-group">
          <label>Nome da Sessão</label>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />
        </div>

        {/* Subtítulo da Tabela */}
        <div className="form-group" style={{ marginBottom: "4px", marginTop: "18px" }}>
          <label>Disciplinas em que a sessão se aplica</label>
        </div>


        {/* Tabela de Disciplinas */}
        {disciplinas.length > 0 ? (
          <div style={{ overflowX: "auto", marginTop: "10px" }}>
            <table className="tabela" style={{ fontSize: "0.75rem", marginTop: "3px" }}>
              <thead style={{ backgroundColor: parametros?.cor_cabecalho || "#156082", color: "white" }}>
                <tr>
                  <th style={{ width: "20%", textAlign: "left", padding: "10px" }}>Código</th>
                  <th style={{ width: "65%", textAlign: "left", padding: "10px" }}>Nome</th>
                  <th style={{ width: "15%", textAlign: "center", padding: "10px" }}>Selecionar</th>
                </tr>
              </thead>
              <tbody>
                {disciplinas.map((disciplina) => (
                  <tr key={disciplina.id}>
                    <td style={{ padding: "10px" }}>{disciplina.codigo}</td>
                    <td style={{ padding: "10px" }}>{disciplina.nome}</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      <input
                        type="checkbox"
                        checked={disciplinasSelecionadas.includes(disciplina.id)}
                        onChange={() => handleDisciplinaCheckbox(disciplina.id)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p style={{ marginTop: "10px" }}>Nenhuma disciplina disponível.</p>
        )}

        {/* Resumo */}
        <div className="form-group full-width" style={{ marginTop: "18px" }}>
          <label>
            Resumo da sessão: <br />
            <small style={{ fontWeight: "400" }}>
              Procure fazer um resumo robusto da sua sessão de aula e, se possível, inclua exemplos que utilizou em sala.
            </small>
          </label>
          <textarea
            value={resumo}
            onChange={(e) => setResumo(e.target.value)}
            rows={6}
            required
            style={{ fontSize: "0.65rem", padding: "10px" }}
          ></textarea>
        </div>

        {/* Botão de ação */}
        <div className="form-actions">
          <button type="submit" className="btn btn-primary">Salvar Sessão</button>
        </div>
      </form>
    </div>
  );
};

export default CadastroSessaoAula;
